export class ReportParent {
  constructor() {
    this.list = []
  }
}

export class Report {
  constructor(id, name, rusName) {
    this.id = id
    this.name = name
    this.rusName = rusName
  }
}
